/**
 * Central application URL – update here and it changes everywhere.
 */
export const APPLY_URL = "https://hilermortgage.my1003app.com/register";
